import { getSignOutUrl } from "../config/Config";

export class SignOutService {
  static signout = () => {
    return getSignOutUrl();
  };
}
